<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'YellowBuckets',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: 'Container ID',
			columns: [
				{
					name: 'Container ID',
					displayName: 'ID',
					sort: 0
				},
				{
					name: 'Container Name',
					displayName: 'Container Name',
					sort: 0
				},
				{
					name: 'Container Type',
					displayName: 'Type',
					sort: 0
				},
				{
					name: 'hcn.job::Registration Number',
					displayName: 'Registration',
					sort: 0
				},
				{
					name: 'Job ID',
					displayName: 'Job ID',
					sort: 0
				},
				{
					name: 'Pallet',
					displayName: 'Pallet',
					sort: 0
				},
				{
					name: 'Package Weight',
					displayName: 'Pkg Wt',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Locked Container',
					displayName: 'Locked',
					sort: 0,
					align: 'center',
					locked: true
				},
				{
					name: 'Net Weight',
					displayName: 'Net Wt',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Gross Weight',
					displayName: 'Gross Wt',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Gross UoM',
					displayName: 'UoM',
					searchName: 'Gross UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Date Created',
					displayName: 'Created',
					sort: 0
				},
				{
					name: 'Created By',
					displayName: 'By',
					searchName: 'Created By',
					sort: 0
				}
			],
			fields: [
				{
					key: 'lockedField',
					label: ''
				},
				{
					key: 'Container ID',
					label: 'ID',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'Container Name',
					label: 'Container Name',
					sortable: true
				},
				{
					key: 'Container Type',
					label: 'Type',
					sortable: true
				},
				{
					key: 'hcn.job::Registration Number',
					label: 'Registration',
					sortable: true
				},
				{
					key: 'Job ID',
					label: 'Job ID',
					sortable: true
				},
				{
					key: 'Pallet',
					label: 'Pallet',
					sortable: true
				},
				{
					key: 'Package Weight',
					label: 'Pkg Wt',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Net Weight',
					label: 'Net Wt',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Gross Weight',
					label: 'Gross Wt',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Gross UoM',
					label: 'UoM',
					searchName: 'Gross UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Created',
					sortable: true
				},
				{
					key: 'Created By',
					label: 'By',
					searchName: 'Created By',
					sortable: true
				}
			],
			headerTitle: 'Yellow Bucket Containers',
			restEntity: 'yb-containers',
			restDetailEntity: 'yb-container-view',
			showExport: true,
			leftmostColumn: 'cell(Container ID)',
			lockedColumn: 'Locked Container'
		}
	},
}
</script>
<style scoped>

</style>